import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import Routes from './routers'

import auth from './auth' // 绑定
import Login from '@/view/login' // 登录
import Forget from '@/view/forget' // 登录
import shopLogin from '@/view/shoplogin' // 店铺登录
import shopList from '@/view/shoplist' // 店铺登录
import Record from '@/view/vshopuserrecord' // 未绑定微信的空页面
import Unbind from '@/view/base/empty/unbind' // 未绑定微信的空页面
import IframeLogin from '@/view/base/iframeLogin' // 自动登录页面

import fetch, { refreshSession } from '../utils/fetch'
import loadRouters from './loadRouters'
import activeLicense from '@/view/base/asset/accountactivation/index'
Vue.use(VueRouter)

const pathPrefix = process.env.PREFIXES

let passport = {
  path: pathPrefix ? `/${pathPrefix}/login` : '/login',
  component: Login,
  name: '',
  hidden: true
}

let shoppassport = {
  path: pathPrefix ? `/${pathPrefix}/shopadmin/login` : '/login',
  component: Login,
  name: '',
  hidden: true
}

let forget = {
  path: pathPrefix ? `/${pathPrefix}/forget` : '/forget',
  component: Forget,
  name: '',
  hidden: true
}

// let shoppassport = {
//   path: pathPrefix ? `/${pathPrefix}/shopadmin/login` : '/shopadmin/login',
//   component: shopLogin,
//   name: '',
//   hidden: true
// }


let shoplistpassport = {
  path: pathPrefix ? `/${pathPrefix}/shopadmin/shoplist` : '/shopadmin/shoplist',
  component: shopList,
  name: '店铺选择列表页',
  hidden: true
}


let unbind = {
  path: pathPrefix ? `/${pathPrefix}/unbind` : '/unbind',
  component: Unbind,
  name: '绑定页',
  hidden: true
}

let activelicense = {
  path: pathPrefix ? `/${pathPrefix}/activelicense` : '/activelicense',
  component: activeLicense,
  name: '未登录用户激活页',
  hidden: true
}

let record = {
  path: '/record',
  component: Record,
  name: '用户体测报告',
  hidden: true
}
let iframeLogin = {
  path: '/iframeLogin',
  component: IframeLogin,
  name: '',
  hidden: true
}
// 销售监控看板
let orderData = {
  path: '/orderData',
  component: () => import('../view/mall/datacube/OrderData.vue'),
  name: 'orderData',
  hidden: true
}

const publicRoutes = [passport, shoppassport, shoplistpassport, unbind, forget, auth, activelicense, record, iframeLogin, orderData]
const router = new VueRouter({
  routes: [...publicRoutes, ...(loadRouters.addRouters() || [])],
  mode: 'history'
})

// Replace the previous account's routes after login without reloading the app.
export function installPermissionRoutes (menus) {
  const routes = [...publicRoutes, ...(loadRouters.addRouters(menus) || [])]
  router.matcher = new VueRouter({ mode: 'history', routes }).matcher
  router.options.routes = routes
}

const routerBefore = {
  goToPath: function (to, from, next) {
    let licenseValid = JSON.parse(Base64.decode(store.getters.license_authorize));
    if (licenseValid && (licenseValid.valid == 'false' || !licenseValid.valid)) {
      if (to.path.indexOf('assetaccountactivation') === -1) {
        next({ path: matchInternalRoute('assetaccountactivation') })
        NProgress.done()
      } else {
        next()
      }
    } else if (to.path === passport.path) {
      next({ path: pathPrefix ? `/${pathPrefix}` : '/' })
      NProgress.done()
    }
    else if (to.path.indexOf("/shopadmin") > -1) {
      next({ path: pathPrefix ? `/${pathPrefix}` : "/login" })
      NProgress.done()
    }
    else if (to.path === shoppassport.path) {
      next({ path: pathPrefix ? `/${pathPrefix}/shopadmin` : '/shopadmin'})
      NProgress.done()
    } else {
      next()
    }
  }
}

const matchInternalRoute = function (name) {
  const menus = store.getters.menus
  if (menus) {
    return findName(menus, name)
  }
  function findName (menus, name) {
    for (let item of menus) {
      let url = item.url.split('/')
      if (url[url.length - 1] === name) {
        return item.url
      }
      if (item.children && item.children.length > 0) {
        let obj = findName(item.children, name)
        if (obj) {
          return obj
        }
      }
    }
  }
}

const whiteList = [passport.path, forget.path, shoppassport.path, activelicense.path, '/record', orderData.path]// 不重定向白名单
router.beforeEach((to, from, next) => {
  if (to.path.indexOf('shopadmin') !== -1) {
    store.dispatch('setLoginType', 'distributor')
  } else {
    store.dispatch('setLoginType', store.getters.login_type)
  }
  // 保证类型已经存储到cookie中了
  NProgress.start()

  let timestamp = (Date.parse(new Date())) / 1000
  if (store.getters.token && whiteList.indexOf(to.path) === -1) {
    // 验证token有效期 提前五分种刷新token
    if (Number(store.getters.exp) - timestamp <= 300) {
      refreshSession().then(() => {
        routerBefore.goToPath(to, from, next)
      })
      .catch(error => {
        if (to.path.indexOf('shopadmin') !== -1) {
          next(shoppassport.path) // 否则全部重定向到登录页
        } else {
          next(passport.path) // 否则全部重定向到登录页
        }
        NProgress.done() // 在hash模式下 改变手动改变hash 重定向回来 不会触发afterEach 暂时hack方案 ps：history模式下无问题，可删除该行！
      })
    } else if (!store.getters.menus) {
      fetch({ url: '/permission', method: 'get'}).then(response => {
        store.dispatch('setMenu', response.data.data)
        installPermissionRoutes(response.data.data)
        routerBefore.goToPath(to, from, next)
      }).catch(() => { next(false); NProgress.done() })
    } else {
      routerBefore.goToPath(to, from, next)
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      if  (to.path.indexOf('shopadmin') !== -1) {
        next(passport.path) // 否则全部重定向到登录页
        // next(shoppassport.path) // 否则全部重定向到登录页
      } else {
        next(passport.path) // 否则全部重定向到登录页
      }
      NProgress.done() // 在hash模式下 改变手动改变hash 重定向回来 不会触发afterEach 暂时hack方案 ps：history模式下无问题，可删除该行！
    }
  }
})

router.afterEach(transition => {
  if (!transition.name && whiteList.indexOf(transition.path) === -1 && store.getters.menus) {
    window.location = store.getters.menus[0].url
  }
  NProgress.done()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js